import {

  addDoc,

  collection,

  deleteDoc,

  doc,

  getDoc,

  getDocs,

  serverTimestamp,

  updateDoc,

} from 'firebase/firestore';

import { db } from '../firebase/firebase-config';

import Document from '../models/Document';

import { COLLECTIONS } from '../platform/constants';

import { LAST_READ_MODULES } from '../platform/lastRead/lastReadModules';

import { markItemAsRead } from '../platform/lastRead/lastReadService';

import { syncAttachmentFields } from '../platform/contentAttachments';

import {

  deleteContentAttachmentStorage,

  uploadFilesAsAttachments,

} from './attachmentUploadService';

import { withTenantScope } from './contentWriteFields';

import {

  buildCreatedAtListQuery,

  buildOrderedListQuery,

  mapAndFilterSnapshot,

} from './tenantListQuery';



export const DOCUMENTS_PAGE_SIZE = 20;



function documentsCollection() {

  return collection(db, COLLECTIONS.DOCUMENTS);

}



function buildDocumentsListQuery(user, {

  pageSize = DOCUMENTS_PAGE_SIZE,

  lastVisible = null,

  tenantId,

  memberships = [],

} = {}) {

  return buildCreatedAtListQuery({

    collectionName: COLLECTIONS.DOCUMENTS,

    tenantId,

    user,

    memberships,

    pageSize,

    lastVisible,

  });

}



function mapDocument(docSnap) {

  return Document.fromFirestore(docSnap);

}



export function buildDocumentsPageQuery(user, tenantId, memberships, options = {}) {

  return buildDocumentsListQuery(user, {

    tenantId,

    memberships,

    pageSize: options.pageSize ?? DOCUMENTS_PAGE_SIZE,

    lastVisible: options.startAfterDoc ?? null,

  });

}



export async function fetchDocumentsPage(user, tenantId, memberships, options = {}) {

  const listQuery = buildDocumentsPageQuery(user, tenantId, memberships, options);

  const querySnapshot = await getDocs(listQuery);

  return {

    documents: mapAndFilterSnapshot(querySnapshot, tenantId, mapDocument),

    lastVisible: querySnapshot.docs[querySnapshot.docs.length - 1] || null,

  };

}



export async function getUserDocumentLastRead(userId) {

  const userDocSnap = await getDoc(doc(db, COLLECTIONS.USERS, userId));

  return userDocSnap.data()?.lastRead?.documents || {};

}



export async function fetchMaxDocumentOrder(tenantId) {

  if (!tenantId) {

    return 0;

  }



  const maxOrderQuery = buildOrderedListQuery({

    collectionName: COLLECTIONS.DOCUMENTS,

    tenantId,

    user: null,

    memberships: [],

    orderField: 'order',

    orderDirection: 'desc',

    pageSize: 1,

  });

  const snapshot = await getDocs(maxOrderQuery);



  if (snapshot.empty) {

    return 0;

  }



  return snapshot.docs[0].data().order || 0;

}



export async function uploadDocumentFiles(files, onProgress, tenantId) {

  return uploadFilesAsAttachments(files, 'documents', { onProgress, tenantId });

}



export async function createDocument(user, documentData, activeTenantId) {

  const attachmentFields = syncAttachmentFields(documentData.attachments || []);



  await addDoc(

    documentsCollection(),

    withTenantScope(activeTenantId, {

      ...documentData,

      ...attachmentFields,

    }),

  );

}



export async function updateDocument(documentId, documentData) {

  const payload = { ...documentData };

  if (documentData.attachments) {

    Object.assign(payload, syncAttachmentFields(documentData.attachments));

  }

  await updateDoc(doc(db, COLLECTIONS.DOCUMENTS, documentId), payload);

}



/** Upload files to Storage and create Firestore document. */

export function uploadAndCreateDocument(user, {

  activeTenantId,

  title,

  description,

  files = [],

  unit,

  unitName,

  onProgress,

}) {

  return uploadDocumentFiles(files, onProgress, activeTenantId)

    .then(async (uploadedAttachments) => {

      const nextOrder = (await fetchMaxDocumentOrder(activeTenantId)) + 1;

      const attachmentFields = syncAttachmentFields(uploadedAttachments);



      await createDocument(user, {

        title,

        description,

        ...attachmentFields,

        uid: user.uid,

        displayName: user.displayName || 'Anonimen',

        createdAt: serverTimestamp(),

        unit,

        unitName,

        order: nextOrder,

      }, activeTenantId);

    });

}



export async function updateDocumentOrder(documentId, order) {

  await updateDoc(doc(db, COLLECTIONS.DOCUMENTS, documentId), { order });

}



export async function deleteDocument(document) {

  try {

    await deleteContentAttachmentStorage(document);

    await deleteDoc(doc(db, COLLECTIONS.DOCUMENTS, document.id));

  } catch (error) {

    if (error.code === 'not-found' || error.message?.includes('object-not-found')) {

      await deleteDoc(doc(db, COLLECTIONS.DOCUMENTS, document.id));

      return;

    }

    throw error;

  }

}



export async function markDocumentAsRead(userId, documentId) {

  await markItemAsRead(userId, LAST_READ_MODULES.DOCUMENTS, documentId);

}


